import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, AccessTime, CancelOutlined } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import AreYouSureAlert from "../../components/Alert/AreYouSureAlert.jsx";
import { NotificationManager } from "react-notifications";
import { roundUpTransaction } from "../../utils/roundUpTransaction.js";

class RevisePriceDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showAlertAccept: false,
            showAlertReject: false,
            bookingDetailsDataPrev: this.props.history.location.state.bookingDetailsData,
            addressData: [],
            cardListNew: [],
            // bookingListHeadingPrev: this.props.history.location.state.heading
        };
    }
    componentDidMount() {
        console.log("REVISE PRICE DETAILS", this.state.bookingDetailsDataPrev);
        this.getAddressData();
        this.getCardList()
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    getAddressData() {
        this.props.getAddressListAction(this.onGetAddressDone);
    }

    getCardList() {
        this.props.cardListAction(this.onCardlistDone);
    }

    onGetAddressDone = (success, data) => {
        if (success) {
            this.setState({
                addressData: data.detail.addresses[0],
                refer_code: data.detail.referral_code
            });
        }
        // console.log("ADDRESSS NEWWWWWW", this.state.addressData);
    };

    onCardlistDone = (success, data) => {
        if (success) {
            this.setState({ cardListNew: data.sources.data[0] });
        }
        // console.log("CARDDDDDDSSS NEWWWWWW", this.state.cardListNew);
    };

    roundUpTransaction = (transaction) => {
        let roundUpValue = transaction.toString()

        if (roundUpValue.includes('.')) {
            return Number(transaction).toFixed(2)
        } else {
            return Number(transaction)
        }
    }

    onAcceptRevisedPrice = async () => {
        var authToken = getCookies();
        console.log('AUTH TOKEN', authToken);
        this.setState({
            showAlert: false
        })
        try {
            const { data } = await Axios({
                method: 'post',
                url: `${SERVER_URL}/booking/user-approve`,
                data: {
                    booking_id: this.state.bookingDetailsDataPrev.id,
                    status: this.state.bookingDetailsDataPrev.status
                },
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('APPROVAL DATA', data);
            if (data.status == 'OK') {
                this.setState({
                    loading: false
                })
                NotificationManager.success(data.message, 'Success');
                this.props.history.push('/user/manage_bookings')
            }
            else {
                this.setState({
                    loading: false
                })
                NotificationManager.error(data.message, 'Error');
                this.props.history.push('/user/manage_bookings')
            }
        } catch (error) {
            console.log("=========================================================APPROVAL ERRORRRRRR", error);
        }
    }

    onRejectRevisedPrice = async () => {
        var authToken = getCookies();
        console.log('AUTH TOKEN', authToken);
        this.setState({
            showAlert: false
        })
        try {
            const { data } = await Axios({
                method: 'post',
                url: `${SERVER_URL}/booking/user-reject`,
                data: {
                    booking_id: this.state.bookingDetailsDataPrev.id,
                    status: this.state.bookingDetailsDataPrev.status
                },
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('APPROVAL DATA', data);
            if (data.status == 'OK') {
                this.setState({
                    loading: false
                })
                NotificationManager.success(data.message, 'Success');
                this.props.history.push('/user/manage_bookings')
            }
            else {
                this.setState({
                    loading: false
                })
                NotificationManager.error(data.message, 'Error');
                this.props.history.push('/user/manage_bookings')
            }
        } catch (error) {
            console.log("=========================================================APPROVAL ERRORRRRRR", error);
        }
    }


    render() {
        let d = Date.now() - Date.parse(this.state.bookingDetailsDataPrev.updated_at)
        let a = d / (60 * 60 * 1000)
        let gap_time = 24 - Math.floor(a)

        var well = {
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        var card = {
            border: '1px solid #eee',
            boxShadow: '1px 1px 20px #ddd',
            borderRadius: '10px',
            marginBottom: 20,
            padding: 20,
        }
        var cardHeading = {
            backgroundColor: '#0078ff',
            color: 'white',
            fontWeight: '600',
            padding: '5px 20px',
            borderRadius: 50,
            fontSize: 18,
            marginBottom: 25,
            marginBottom: 20
        }
        var infoHead = {
            color: 'green',
            fontSize: 18,
            fontWeight: '700',
            marginBottom: 0
        }

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        let originalDate = this.state.bookingDetailsDataPrev.booking_date;
        let year = originalDate.substring(0, 4)
        let month = (Number(originalDate.substring(5, 7)) - 1);
        let date = originalDate.substring(8, 10)
        let formattedDate = monthNames[month] + ' ' + date + ', ' + year;

        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Revise Price Details'
                                goback={() => this.props.history.goBack(null)}
                            />
                            <div 
                            id="booking_details"
                            style={{
                                display: 'flex',
                                width: '100%'
                            }}>
                                <div
                                id="booking_details1"
                                 style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '50%',
                                    padding: 10
                                }}>
                                    <div style={card}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <p style={cardHeading}>Booking Info</p>
                                        </div>
                                        <p style={infoHead}>
                                            {formattedDate}
                                        </p>
                                        <p style={{
                                            fontSize: 18,
                                            marginBottom: 20
                                        }}>{this.state.bookingDetailsDataPrev.booking_slot}</p>
                                        <p style={{
                                            fontSize: 18,
                                            marginBottom: 0,
                                        }}>Booking# <span style={{ color: '#0078ff', fontWeight: 'bold' }}>{this.state.bookingDetailsDataPrev.booking_number}</span></p>
                                        <p style={{
                                            fontSize: 18,
                                        }}>{this.state.bookingDetailsDataPrev.taskData.full_name.service} ({this.state.bookingDetailsDataPrev.taskData.full_name.master_category} / {this.state.bookingDetailsDataPrev.taskData.full_name.category})</p>
                                        <p style={{
                                            fontSize: 18,
                                            marginBottom: 0,
                                        }}>Description: {this.state.bookingDetailsDataPrev.taskData.description}</p>
                                        <p style={{
                                            fontSize: 18,
                                            marginBottom: 0,
                                        }}>Booking Type: {this.state.bookingDetailsDataPrev.taskData.service_type} | {this.state.bookingDetailsDataPrev.taskData.booking_type}</p>
                                    </div>
                                    <div style={card}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <p style={cardHeading}>Payment Method</p>
                                            {/* <p>Edit</p> */}
                                        </div>
                                        <p style={{...infoHead, marginBottom: 10}}>Card - {this.state.cardListNew.brand}</p>
                                        <p style={{
                                            fontSize: 18,
                                        }}>Card Number - **** **** **** {this.state.cardListNew.last4}</p>
                                        <p style={{
                                            fontSize: 18,
                                        }}>Expiry - {this.state.cardListNew.exp_month}/{this.state.cardListNew.exp_year}</p>
                                        <p style={{
                                            fontSize: 18,
                                        }}>Amount Payable - ${roundUpTransaction(this.state.bookingDetailsDataPrev.booking_value - this.state.bookingDetailsDataPrev.original_price)}</p>
                                    </div>
                                </div>
                                <div 
                                id="booking_details1"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    width: '50%',
                                    padding: 10
                                }}>
                                    <div style={card}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <p style={cardHeading}>Revise Price Details</p>
                                        </div>
                                        <p style={{
                                            fontSize: 18,
                                        }}>Original Price: ${roundUpTransaction(this.state.bookingDetailsDataPrev.original_price)}</p>
                                        <p style={{ fontWeight: 'bold', fontSize: 18, }}>Proposed Price: ${roundUpTransaction(this.state.bookingDetailsDataPrev.booking_value)}</p>
                                        <p style={{ fontWeight: 'bold', fontSize: 18, }}>Reason: </p>
                                        <p style={{
                                            border: '1px solid #eee',
                                            padding: 15,
                                            margin: '5px 0',
                                            borderRadius: 5,
                                            fontSize: 18,
                                        }}>{this.state.bookingDetailsDataPrev.revise_price_reason}</p>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginTop: 20,
                                        marginBottom: 25
                                    }}>
                                        <p
                                            onClick={() => {
                                                this.setState({ showAlert2: true })
                                            }}
                                            style={{
                                                backgroundColor: 'red',
                                                padding: 10,
                                                color: '#fff',
                                                borderRadius: 5,
                                                fontSize: 17,
                                                textAlign: 'center',
                                                marginRight: 15,
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 110
                                            }}>Decline</p>
                                        <p
                                            onClick={() => {
                                                this.setState({ showAlert1: true })
                                            }}
                                            style={{
                                                backgroundColor: '#0078ff',
                                                padding: 10,
                                                color: '#fff',
                                                borderRadius: 5,
                                                fontSize: 17,
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 110
                                            }}>Accept</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AreYouSureAlert
                    open={this.state.showAlert1}
                    title=""
                    content="By accepting this you agree with the adjusted pricing shown above. You will be automatially charged the difference between the orginal amount and the new amount you are accepting. Do you want to continue?"
                    close={() => this.setState({ showAlert1: false })}
                    handleYes={this.onAcceptRevisedPrice}
                    handleNo={() => this.setState({ showAlert1: false })}
                />
                <AreYouSureAlert
                    open={this.state.showAlert2}
                    title=""
                    content="By declining this price increase the job will be cancelled and the Pro will not start/finish the work and you will be refunded. Do you want to continue?"
                    close={() => this.setState({ showAlert2: false })}
                    handleYes={this.onRejectRevisedPrice}
                    handleNo={() => this.setState({ showAlert2: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(RevisePriceDetails));



// WEBPACK FOOTER //
// ./src/views/User/RevisePriceDetailsScreenNew.jsx